// extracted by mini-css-extract-plugin
export default {"CartButtonContainer":"CartChip_CartButtonContainer__p60bc","Badge":"CartChip_Badge__fTbD-"};